import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Element } from '../../html/element'
import { Loading } from '../../loading'
import { Notification } from '../../notification'
import { Item } from './Item'
import './i18n'
import classes from './index.module.scss'
import { resetStore, selectIsLoading, selectReportData } from './store/slice'
import { getReportItems } from './store/thunk'

export const businessCreditReportTypes = {
  POPUP: 'popup',
  PREVIEW: 'preview',
}

export const BusinessCreditReport = ({ type }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const data = useSelector(selectReportData)
  const isLoading = useSelector(selectIsLoading)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getReportItems({
        OrganizationId: params.organizationId,
      }),
    )
  }, [])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  if (isLoading) {
    return (
      <div className="positionRelative" style={{ height: 200 }}>
        <Loading />
      </div>
    )
  }

  if (!data.length) {
    return (
      <div style={{ height: 200 }}>
        <Notification />
      </div>
    )
  }

  if (type === businessCreditReportTypes.POPUP) {
    return (
      <div className={classes.popupContainer}>
        {data.map((item, index) => (
          <Element
            key={index}
            className={classes.reportItem}
            style={{ backgroundColor: '#FFFFFF' }}
          >
            <Item item={item} key={index} />
          </Element>
        ))}
      </div>
    )
  }

  return (
    <div className={classes.previewContainer}>
      {data.map((item, index) => (
        <Fragment key={index}>
          {index !== 0 && (
            <Element
              className={classes.divider}
              style={{ borderTop: '1px solid #e8eaed' }}
            />
          )}
          <Item item={item} />
        </Fragment>
      ))}
    </div>
  )
}
